import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

/**
 * Hook to determine if the Group Practice Invoice page should be enabled.
 *
 * Access control:
 * - Local & Staging: Always enabled for everyone
 * - Production: GrowthBook feature flag with Saved Groups (orgId + healthieUserId)
 *
 * Priority (highest to lowest):
 * 1. URL query parameter ?useGroupPractice=true|false (for testing)
 * 2. Non-production environments: always enabled
 * 3. GrowthBook feature flag 'group-practice-provider-portal-invoice'
 */
export const useGroupPracticeInvoiceEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.GROUP_PRACTICE_INVOICE,
  );

  // Query param override for testing
  const queryParam = router.query['useGroupPractice'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
